import * as React from "react";
const MiniHaircutFemale2 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="468 75 200 300">
		<title>{"coiffure f 2"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="Calque_10" data-name="Calque 10">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M511.49,343.42s-30.67-13.42-36.43-44.1-5.75-99.7,0-113.12,15.34-46,55.61-61.35S615,136.35,615,136.35s32.59,13.42,36.43,82.44,0,70.94-5.76,86.28S628.45,333.83,615,335.75c1.91-17.26,11.5-51.77,11.5-69s0-55.61-3.83-67.11-21.09-38.35-21.09-38.35S615,184.28,615,197.7c-40.27,3.84-46,3.84-61.36,0s-44.09-23-47.93-28.76c1.92,13.43-3.83,32.6-3.83,32.6s-7.67,21.09-1.92,65.19S511.49,343.42,511.49,343.42Z"
			/>
		</g>
	</svg>
);
export default MiniHaircutFemale2;
